export const toggleText = $el => {
    if ($el[0].innerText.toLowerCase().includes('показать')) {
        const str = $el[0].innerText.toLowerCase().replace(/показать/, 'скрыть');
        $el.text(str);
    } else {
        const str = $el[0].innerText.toLowerCase().replace(/скрыть/, 'показать');
        $el.text(str);
    }
};
